<template>
    <div>
        <div class="page_none">
        <van-empty description="找不到内容~" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "none",
        components: {

        },
        data() {
            return {
                timer: null
            }
        },
        watch: {

        },
        activated() {
            let that = this
            that.timer = setTimeout(function () {
                console.log(that.$route.path)
                if(that.$route.path !== '/free') {
                    that.$router.replace({path: '/free'})
                }
            }, 1000 * 8)
        },
        deactivated(){
            let that = this
            clearTimeout(that.timer)
            that.timer = null
        },
        methods: {

        }
    }
</script>

<style scoped>
    .page_none{height:600px;}
</style>
